import { AuthEnvironment } from "../interfaces/IAuthenticationProvider";

export function GetAugloopResourceUrl(environment: AuthEnvironment): string {
    switch (environment) {
        case AuthEnvironment.PPE:
            return "https://augloop-int.officeppe.com/v2";
        case AuthEnvironment.Prod:
        case AuthEnvironment.GCC:
        case AuthEnvironment.GCCHigh:
        case AuthEnvironment.DOD:
        case AuthEnvironment.USNAT:
        case AuthEnvironment.USSEC:
            return "https://augloop.office.com/v2";   
        default:
            throw new Error(`Unsupported auth environment: ${environment}`);

    }
}
